import { CSSProperties, ReactNode } from 'react'
import styles from './Field.module.css'

/**
 * 시안 `.fld` 이식. `width` 는 flex 축약값 그대로 인라인 `flex` 로 넘긴다(예: '0 0 132px').
 *
 * 코드 리뷰 반영(LOGISPRD-12506 Task 6, Finding 4) — 전에는 `<label>` 이 `children` 의 형제일
 * 뿐이라 htmlFor/id 없이는 스크린리더도 라벨 클릭 포커스도 되지 않았다. 래퍼 자체를 `<label>`
 * 로 바꿔(옵션 a) 암시적으로 연결한다 — `useId`+`htmlFor`(옵션 b)보다 단순하고, 호출부가 id 를
 * 넘길 필요가 없어 기존 사용처(예: `HoldCreateForm`)를 하나도 고치지 않아도 된다. Task 7~10 도
 * `Field` 를 그대로 쓰면 자동으로 이 연결을 받는다.
 */
export type FieldProps = {
  label: string
  width?: string
  children: ReactNode
}

export const Field = ({ label, width, children }: FieldProps): JSX.Element => {
  const style: CSSProperties | undefined = width ? { flex: width } : undefined

  return (
    <label className={styles.fld} style={style}>
      <span>{label}</span>
      {children}
    </label>
  )
}
